import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { LayoutDashboard, Users, UserCheck, Building2, Target, Settings, Sun, Moon, Workflow, CreditCard, Megaphone, WalletCards, FileAudio } from 'lucide-react';
import { useSettings } from '../contexts/SettingsContext';
import { useWhatsApp } from '../contexts/WhatsAppContext';

const Sidebar = () => {
  const location = useLocation();
  const { companyName, companyLogo, darkMode, setDarkMode } = useSettings();
  const { whatsappConnected } = useWhatsApp();
  
  console.log('[Sidebar] Render - whatsappConnected:', whatsappConnected, 'LED class:', whatsappConnected ? 'bg-green-500' : 'bg-red-500');
  
  const menuItems = [
    { path: '/', icon: LayoutDashboard, label: 'Dashboard' },
    { path: '/leads', icon: Users, label: 'Leads' },
    { path: '/clients', icon: UserCheck, label: 'Clientes' },
    { path: '/partner-clients', icon: Building2, label: 'Clientes Parceiro' },
    { path: '/production-line', icon: Workflow, label: 'Esteira de Produção' },
    // RATING_CONTENT_MENU_V1
    { path: '/rating-content', icon: FileAudio, label: 'Conteúdo Rating' },
    { path: '/pix-facilitado', icon: CreditCard, label: 'PIX Facilitado' },
    { path: '/remarketing', icon: Target, label: 'Remarketing' },
    // CRM_PROMOTIONS_MENU_V1
    { path: '/promotions', icon: Megaphone, label: 'Promoções' },
    // FINANCEIRO_RATING_MENU_V1
    { path: '/financial', icon: WalletCards, label: 'Financeiro' },
    { path: '/settings', icon: Settings, label: 'Configurações' },
  ];

  return (
    <aside className={`w-64 ${darkMode ? 'bg-gray-900 text-white' : 'bg-white text-gray-900 border-r border-gray-200'} p-4`}>
      <div className="mb-8">
        {companyLogo ? (
          <div className="flex items-center gap-3 mb-2">
            <img 
              src={companyLogo} 
              alt="Logo" 
              className="h-12 w-12 object-cover rounded-full"
            />
            <div className="flex items-center gap-2">
              <div className={`w-3 h-3 rounded-full ${whatsappConnected ? 'bg-green-500' : 'bg-red-500'} ${!whatsappConnected ? 'animate-pulse' : ''}`}></div>
              <h1 className={`text-xl font-bold ${darkMode ? 'text-blue-400' : 'text-blue-600'}`}>
                {companyName}
              </h1>
            </div>
          </div>
        ) : (
          <div className="flex items-center gap-2 mb-2">
            <div className={`w-3 h-3 rounded-full ${whatsappConnected ? 'bg-green-500' : 'bg-red-500'} ${!whatsappConnected ? 'animate-pulse' : ''}`}></div>
            <h1 className={`text-2xl font-bold ${darkMode ? 'text-blue-400' : 'text-blue-600'}`}>
              {companyName}
            </h1>
          </div>
        )}
        <p className={`text-sm ${darkMode ? 'text-gray-400' : 'text-gray-600'}`}>Painel Administrativo</p>
      </div>
      
      <nav className="space-y-2">
        {menuItems.map((item) => {
          const Icon = item.icon;
          const isActive = location.pathname === item.path;
          
          return (
            <Link
              key={item.path}
              to={item.path}
              className={`flex items-center gap-3 px-4 py-3 rounded-lg transition-colors ${
                isActive 
                  ? 'bg-blue-600 text-white' 
                  : darkMode 
                    ? 'text-gray-300 hover:bg-gray-800' 
                    : 'text-gray-700 hover:bg-gray-100'
              }`}
            >
              <Icon size={20} />
              <span>{item.label}</span>
            </Link>
          );
        })}
      </nav>

      <div className="mt-8 pt-4 border-t border-gray-700">
        <button
          onClick={() => setDarkMode(!darkMode)}
          className={`flex items-center gap-3 px-4 py-3 rounded-lg transition-colors w-full ${
            darkMode 
              ? 'text-gray-300 hover:bg-gray-800' 
              : 'text-gray-700 hover:bg-gray-100'
          }`}
        >
          {darkMode ? <Sun size={20} /> : <Moon size={20} />}
          <span>{darkMode ? 'Modo Claro' : 'Modo Escuro'}</span>
        </button>
      </div>
    </aside>
  );
};

export default Sidebar;
